// Valor em reais por extenso, como vai no recibo ("mil e quinhentos reais").
const UNIDADES = [
  'zero', 'um', 'dois', 'três', 'quatro', 'cinco', 'seis', 'sete', 'oito', 'nove', 'dez',
  'onze', 'doze', 'treze', 'quatorze', 'quinze', 'dezesseis', 'dezessete', 'dezoito', 'dezenove',
];
const DEZENAS = ['', '', 'vinte', 'trinta', 'quarenta', 'cinquenta', 'sessenta', 'setenta', 'oitenta', 'noventa'];
const CENTENAS = ['', 'cento', 'duzentos', 'trezentos', 'quatrocentos', 'quinhentos', 'seiscentos', 'setecentos', 'oitocentos', 'novecentos'];

// 1 a 999
function ate999(n) {
  if (n === 100) return 'cem';
  const partes = [];
  const c = Math.floor(n / 100);
  const r = n % 100;
  if (c) partes.push(CENTENAS[c]);
  if (r) {
    if (r < 20) partes.push(UNIDADES[r]);
    else {
      const u = r % 10;
      partes.push(u ? `${DEZENAS[Math.floor(r / 10)]} e ${UNIDADES[u]}` : DEZENAS[Math.floor(r / 10)]);
    }
  }
  return partes.join(' e ');
}

const ESCALAS = [
  () => '',
  (v) => (v === 1 ? 'mil' : `${ate999(v)} mil`),
  (v) => (v === 1 ? 'um milhão' : `${ate999(v)} milhões`),
  (v) => (v === 1 ? 'um bilhão' : `${ate999(v)} bilhões`),
];

// Número inteiro (0 a 999.999.999.999) por extenso.
export function inteiroPorExtenso(n) {
  if (!Number.isInteger(n) || n < 0 || n >= 1e12) throw new Error('Número fora do alcance do extenso');
  if (n === 0) return 'zero';
  const grupos = [];
  for (let resto = n, escala = 0; resto > 0; resto = Math.floor(resto / 1000), escala += 1) {
    const valor = resto % 1000;
    if (valor) grupos.push({ valor, escala });
  }
  grupos.reverse(); // do maior para o menor
  let texto = '';
  grupos.forEach(({ valor, escala }, i) => {
    const parte = escala === 0 ? ate999(valor) : ESCALAS[escala](valor);
    if (i === 0) texto = parte;
    else {
      // "mil e cem", "mil e um"; mas "mil cento e dez"
      const ultimo = i === grupos.length - 1;
      texto += ultimo && (valor < 100 || valor % 100 === 0) ? ` e ${parte}` : ` ${parte}`;
    }
  });
  return texto;
}

// 1500 → "mil e quinhentos reais"; 1.5 → "um real e cinquenta centavos"
export function reaisPorExtenso(valor) {
  const totalCentavos = Math.round(Number(valor) * 100);
  if (!Number.isFinite(totalCentavos) || totalCentavos < 0) throw new Error('Valor inválido');
  const reais = Math.floor(totalCentavos / 100);
  const centavos = totalCentavos % 100;
  const partes = [];
  if (reais > 0) {
    // "um milhão de reais", mas "um milhão e cem mil reais"
    const redondo = reais >= 1e6 && reais % 1e6 === 0;
    partes.push(`${inteiroPorExtenso(reais)}${redondo ? ' de' : ''} ${reais === 1 ? 'real' : 'reais'}`);
  }
  if (centavos > 0) partes.push(`${inteiroPorExtenso(centavos)} ${centavos === 1 ? 'centavo' : 'centavos'}`);
  return partes.length ? partes.join(' e ') : 'zero real';
}
